/**
 * defa.views.UserLoginCreateDualContainer
 * Shows both Login and Register at the same time.
 * @version 1.2.1
 */
import UserCreateForm from 'scripts/defa/users/view-user-create-form';
import UserLoginForm  from 'scripts/defa/users/view-user-login-form';
import Container      from 'scripts/poppet/container';
import template       from 'templates/userLoginCreateDualContainer.jst.html';

const selectors = {
	regionLogin    : '[data-region=user-login]',
	regionCreate   : '[data-region=user-create]',
	buttonBluetooth: '[data-click=unit-bluetooth]',
	buttonCreate   : '[data-click=user-create]',
};

const UserLoginCreateDualContainer = Container.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		login : selectors.regionLogin,
		create: selectors.regionCreate,
	},
	
	ui: {
		buttonBluetooth: selectors.buttonBluetooth,
		buttonCreate   : selectors.buttonCreate,
	},
	
	events: {
		'click @ui.buttonBluetooth': 'onClickBluetooth',
		'click @ui.buttonCreate'   : 'onClickCreate',
	},
	
	templateContext: function () {
		return {
			isBluetoothAvailable: this.options.isBluetoothAvailable,
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the end user clicks the bluetooth button.
	 * @void
	 */
	onClickBluetooth: function () {
		this.trigger( 'nav', 'unit:bluetooth' );
	},
	
	/**
	 * Triggers when the end user clicks the create button.
	 * @void
	 */
	onClickCreate: function () {
		this.trigger( 'nav', 'user:create' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches this containers views
	 * @void
	 */
	attachView: function () {
		
		let userLoginForm = new UserLoginForm( _.extend( {
			model  : this.options.user,
			email  : '',
			context: 'dual',
		}, this.options ) );
		
		let userCreateForm = new UserCreateForm( _.extend( {
			model  : this.options.currentUser,
			email  : '',
			token  : '',
			context: 'dual',
		}, this.options ) );
		
		this.showChildView( 'login', userLoginForm, false );
		this.showChildView( 'create', userCreateForm, this.options.closeLink );
	},
	
} );

export default UserLoginCreateDualContainer;